(function () {
  "use strict";

  if (!window.ecoflowIsHomePage) return;

  var doc = document;
  var fullBundleRequested = false;
  var deferredHeaderRequest;

  function ready(callback) {
    if (doc.readyState === "loading") {
      doc.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }
    callback();
  }

  function requestFullBundle(reason) {
    if (typeof window.ecoflowLoadHomeDeferredBundle === "function") {
      if (fullBundleRequested) return;
      fullBundleRequested = true;
      window.ecoflowLoadHomeDeferredBundle(reason || "critical-interaction").catch(function () {
        fullBundleRequested = false;
      });
    }
  }

  function deferBundleLoad(reason) {
    window.requestAnimationFrame(function () {
      requestFullBundle(reason || "deferred-interaction");
    });
  }

  function isFullBundleReady() {
    return window.ecoflowHomeFullBundleLoaded === true;
  }

  function query(selector, root) {
    return (root || doc).querySelector(selector);
  }

  function queryAll(selector, root) {
    return Array.prototype.slice.call((root || doc).querySelectorAll(selector));
  }

  function hydrateLazyMedia(root) {
    if (!root) return;

    queryAll("source[data-srcset], source[data-home-slide-srcset]", root).forEach(function (source) {
      var dataSrcset = source.getAttribute("data-srcset") || source.getAttribute("data-home-slide-srcset");
      if (!dataSrcset) return;
      source.setAttribute("srcset", dataSrcset);
      source.removeAttribute("data-srcset");
      source.removeAttribute("data-home-slide-srcset");
    });

    queryAll("img[data-src], img[data-srcset], img[data-home-slide-src], img[data-home-slide-srcset]", root).forEach(function (image) {
      var dataSrc = image.getAttribute("data-src") || image.getAttribute("data-home-slide-src");
      var dataSrcset = image.getAttribute("data-srcset") || image.getAttribute("data-home-slide-srcset");

      if (dataSrcset) {
        image.setAttribute("srcset", dataSrcset);
        image.removeAttribute("data-srcset");
        image.removeAttribute("data-home-slide-srcset");
      }

      if (dataSrc) {
        image.setAttribute("src", dataSrc);
        image.removeAttribute("data-src");
        image.removeAttribute("data-home-slide-src");
      }

      image.classList.remove("lazyload");
      image.classList.add("lazyloaded");
    });
  }

  function fetchDeferredHeader(url) {
    if (!deferredHeaderRequest) {
      deferredHeaderRequest = window.fetch(url, { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("Deferred mega menu request failed");
          return response.text();
        })
        .then(function (html) {
          return new window.DOMParser().parseFromString(html, "text/html");
        });
    }

    return deferredHeaderRequest;
  }

  function ensureDeferredMegaMenu(item) {
    var slot = query("[data-ecoflow-deferred-mega-panel]", item);
    if (!slot || slot.dataset.loaded === "true") {
      return Promise.resolve(true);
    }

    if (slot.loadingPromise) return slot.loadingPromise;

    item.dataset.ecoflowDeferredMegaLoading = "true";
    slot.setAttribute("aria-busy", "true");
    slot.loadingPromise = fetchDeferredHeader(slot.getAttribute("data-section-url"))
      .then(function (responseDoc) {
        var source;

        if (item.getAttribute("data-ecoflow-deferred-mega-menu") === "desktop") {
          var menuIndex = slot.getAttribute("data-menu-index");
          var sourceItem = query('.nav-bar__item[data-menu-index="' + menuIndex + '"]', responseDoc);
          source = sourceItem && query(".mega-menu", sourceItem);
        } else {
          var title = slot.getAttribute("data-menu-title");
          var sourceButton = queryAll(".mobile-nav .megamenu-btn", responseDoc).find(function (button) {
            return button.getAttribute("data-target") === title;
          });
          source = sourceButton && query(".mobile-nav__dropdown", sourceButton.parentElement);
        }

        if (!source) throw new Error("Deferred mega menu response is missing panel");

        var panel = source.cloneNode(true);
        hydrateLazyMedia(panel);
        slot.dataset.loaded = "true";
        slot.replaceWith(panel);
        item.dataset.ecoflowDeferredMegaLoaded = "true";
        item.dataset.ecoflowDeferredMegaLoading = "false";
        return true;
      })
      .catch(function () {
        slot.setAttribute("aria-busy", "false");
        slot.dataset.loadError = "true";
        slot.loadingPromise = null;
        item.dataset.ecoflowDeferredMegaLoading = "false";
        return false;
      });

    return slot.loadingPromise;
  }

  function initDeferredMegaMenus() {
    function setDesktopDeferredItemOpenState(targetItem, isOpen) {
      targetItem.classList.toggle("visible", isOpen);
      var link = query(".nav-bar__link", targetItem);
      var overlay = query(".mega_menu_overlay");
      if (link) {
        link.classList.toggle("active", isOpen);
        link.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }
      if (overlay) {
        var hasVisibleMenu = queryAll('[data-ecoflow-deferred-mega-menu="desktop"].visible').length > 0;
        overlay.style.display = hasVisibleMenu ? "block" : "none";
      }
    }

    function closeOtherDeferredDesktopItems(currentItem) {
      queryAll('[data-ecoflow-deferred-mega-menu="desktop"]').forEach(function (candidate) {
        if (candidate === currentItem) return;
        candidate.dataset.ecoflowDeferredHoverIntent = "false";
        setDesktopDeferredItemOpenState(candidate, false);
      });
    }

    queryAll('[data-ecoflow-deferred-mega-menu="desktop"]').forEach(function (item) {
      function openDesktopDeferredItem() {
        closeOtherDeferredDesktopItems(item);
        setDesktopDeferredItemOpenState(item, true);
      }

      function closeDesktopDeferredItem() {
        setDesktopDeferredItemOpenState(item, false);
      }

      function openAfterLoad() {
        item.dataset.ecoflowDeferredHoverIntent = "true";
        closeOtherDeferredDesktopItems(item);
        ensureDeferredMegaMenu(item).then(function (loaded) {
          if (!loaded) return;
          var hasFocusWithin = item.contains(doc.activeElement);
          if (item.dataset.ecoflowDeferredHoverIntent !== "true" && !hasFocusWithin) return;
          openDesktopDeferredItem();
          requestFullBundle("desktop-mega-menu");
        });
      }

      item.addEventListener("mouseenter", openAfterLoad);
      item.addEventListener("focusin", openAfterLoad);
      item.addEventListener("mouseleave", function () {
        if (isFullBundleReady()) return;
        item.dataset.ecoflowDeferredHoverIntent = "false";
        closeDesktopDeferredItem();
      });
      item.addEventListener("focusout", function (event) {
        if (isFullBundleReady()) return;
        var nextTarget = event.relatedTarget;
        if (nextTarget && item.contains(nextTarget)) return;
        item.dataset.ecoflowDeferredHoverIntent = "false";
        closeDesktopDeferredItem();
      });
    });
  }

  function closeSearch() {
    var searchButton = query(".header-search-button.active");
    var searchDropdown = query(".search-form__container.show_form");
    var overlay = query(".mega_menu_overlay");

    if (searchButton) searchButton.classList.remove("active");
    if (searchDropdown) {
      searchDropdown.classList.remove("show_form");
      var predictive = query(".predictive-search-wrapper", searchDropdown);
      if (predictive) predictive.classList.remove("visible");
    }

    doc.body.classList.remove("show_overlay");
    doc.body.classList.remove("show_search_overlay");
    if (overlay) overlay.style.display = "none";
  }

  function closeCartDrawer() {
    var drawer = query("#sidebar-cart");
    if (!drawer) return;
    drawer.classList.remove("show");
    doc.body.classList.remove("show_overlay");
  }

  function initHeader() {
    var body = doc.body;
    var header = query(".site-header");
    var headerSection = query("#shopify-section-header");
    var mobileNavToggle = query(".js-mobile-nav-toggle");
    var mobileNavContainer = query(".mobile-nav-wrapper");
    var mobileNav = query("#MobileNav");
    var mobileOverlay = query(".mobile_menu_overlay");
    var megaOverlay = query(".mega_menu_overlay");

    // Match the full theme header layout before any interaction-triggered
    // bundle load so the homepage hero does not shift when theme.js starts.
    if (header && header.getAttribute("data-enable_overlap_header") === "false" && headerSection) {
      headerSection.classList.add("showAlternateHeader");
      headerSection.classList.add("no-overlap");
      body.classList.add("no-overlap-header");
    }

    function closeMobileNav() {
      if (!mobileNavToggle || !mobileNavContainer) return;

      queryAll(".js-toggle-submenu.is-active").forEach(function (element) {
        element.classList.remove("is-active");
        if (element.parentElement) {
          element.parentElement.classList.remove("is-active");
        }
      });

      mobileNavContainer.classList.remove("js-menu--is-open");
      body.classList.remove("js-menu--is-open");
      mobileNavToggle.classList.add("mobile-nav--open");
      mobileNavToggle.classList.remove("mobile-nav--close");
      mobileNavToggle.setAttribute("aria-expanded", "false");
    }

    function openMobileNav() {
      if (!mobileNavToggle || !mobileNavContainer) return;

      closeSearch();
      closeCartDrawer();

      var headerHeight = header ? header.offsetHeight : 0;
      mobileNavContainer.classList.add("js-menu--is-open");
      body.classList.add("js-menu--is-open");
      mobileNavToggle.classList.add("mobile-nav--close");
      mobileNavToggle.classList.remove("mobile-nav--open");
      mobileNavToggle.setAttribute("aria-expanded", "true");
      mobileNavContainer.style.top = Math.max(0, headerHeight - 2) + "px";

      if (mobileNav) {
        window.requestAnimationFrame(function () {
          var mobileNavHeight = mobileNav.offsetHeight;
          queryAll(".mobile-nav__dropdown", mobileNav).forEach(function (dropdown) {
            mobileNavHeight = Math.max(mobileNavHeight, dropdown.offsetHeight);
          });
          if (mobileNavHeight) mobileNav.style.minHeight = mobileNavHeight + "px";
        });
      }
    }

    if (mobileNavToggle && mobileNavContainer) {
      mobileNavToggle.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();

        if (mobileNavContainer.classList.contains("js-menu--is-open")) {
          closeMobileNav();
        } else {
          openMobileNav();
        }

        deferBundleLoad("mobile-menu");
      });
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener("click", function () {
        if (isFullBundleReady()) return;
        closeMobileNav();
      });
    }

    queryAll(".js-toggle-submenu").forEach(function (button) {
      function toggleButtonState() {
        var expanded = button.getAttribute("aria-expanded") === "true";
        var nextExpanded = !expanded;
        button.setAttribute("aria-expanded", nextExpanded ? "true" : "false");
        button.classList.toggle("is-active", nextExpanded);
        if (button.parentElement) {
          button.parentElement.classList.toggle("is-active", nextExpanded);
        }
      }

      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        var deferredItem = button.closest("[data-ecoflow-deferred-mega-menu]");
        if (deferredItem) {
          if (deferredItem.dataset.ecoflowDeferredMegaLoading === "true") return;
          ensureDeferredMegaMenu(deferredItem).then(function (loaded) {
            if (!loaded) return;
            toggleButtonState();
            deferBundleLoad("mobile-deferred-mega-menu");
          });
        } else {
          toggleButtonState();
          deferBundleLoad("mobile-submenu");
        }
      });
    });

    queryAll(".header-search-button").forEach(function (button) {
      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeMobileNav();
        closeCartDrawer();

        var searchRoot = button.closest(".search-bar__interior");
        var searchDropdown = searchRoot ? query(".search-form__container", searchRoot) : null;
        var predictive = searchDropdown ? query(".predictive-search-wrapper", searchDropdown) : null;
        var willOpen = searchDropdown && !button.classList.contains("active");

        closeSearch();

        if (willOpen) {
          searchDropdown.classList.add("show_form");
          if (predictive) predictive.classList.add("visible");
          button.classList.add("active");
          body.classList.add("show_overlay");
          body.classList.add("show_search_overlay");
          if (megaOverlay) megaOverlay.style.display = "block";
        }

        deferBundleLoad("search");
      });
    });

    queryAll(".search-close").forEach(function (button) {
      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeSearch();
      });
    });

    queryAll(".search-button__submit").forEach(function (button) {
      button.addEventListener("click", function () {
        deferBundleLoad("search-submit");
      });
    });

    queryAll("[data-customer-menu-trigger]").forEach(function (button) {
      var menu = button.closest("[data-customer-menu]");
      if (!menu) return;

      button.addEventListener("click", function (event) {
        if (menu.dataset.customerMenuReady === "true") return;
        event.preventDefault();
        event.stopImmediatePropagation();
        menu.dataset.customerMenuOpen = menu.dataset.customerMenuOpen === "true" ? "false" : "true";
        deferBundleLoad("header-account");
      }, true);
    });

    function cancelPendingAccountMenu(event) {
      queryAll("[data-customer-menu-open]").forEach(function (menu) {
        if (event.type === "click" && menu.contains(event.target)) return;
        delete menu.dataset.customerMenuOpen;
      });
    }

    doc.addEventListener("click", cancelPendingAccountMenu, true);

    queryAll("[data-header-login-trigger]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        var dialog = query("#login-popup-dialog");

        event.preventDefault();

        if (dialog && typeof dialog.showModal === "function") {
          if (!dialog.open) dialog.showModal();
          deferBundleLoad("header-login");
          return;
        }

        if (typeof window.openLoginPopupDialog === "function") {
          window.openLoginPopupDialog();
        }

        deferBundleLoad("header-login");
      });
    });

    var headerCart = query("#HeaderCart");
    var cartDrawer = query("#sidebar-cart");
    if (headerCart && cartDrawer) {
      headerCart.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeSearch();
        closeMobileNav();
        cartDrawer.classList.add("show");
        body.classList.add("show_overlay");
        deferBundleLoad("cart-drawer");
      });
    }

    queryAll('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]').forEach(function (button) {
      button.addEventListener("click", function (event) {
        if (isFullBundleReady()) return;
        event.preventDefault();
        closeCartDrawer();
      });
    });

    doc.addEventListener("keyup", function (event) {
      if (event.key !== "Escape" && event.keyCode !== 27) return;
      cancelPendingAccountMenu(event);
      if (isFullBundleReady()) return;
      closeSearch();
      closeCartDrawer();
      closeMobileNav();
    });
  }

  function removeCriticalPageDots() {
    queryAll("[data-ecoflow-critical-dots]").forEach(function (dots) {
      dots.remove();
    });
  }

  function createCriticalPageDots(section, sliderEl, slides, setSlide, warmSlideMedia) {
    if (!sliderEl || slides.length <= 1) return null;
    if (sliderEl.querySelector(".flickity-page-dots")) return null;

    var dots = document.createElement("ol");
    dots.className = "flickity-page-dots";
    dots.setAttribute("data-ecoflow-critical-dots", "true");
    dots.style.setProperty("--current-progress", "0%");

    slides.forEach(function (slide, index) {
      var dot = document.createElement("li");
      dot.className = index === 0 ? "is-selected" : "";
      dot.setAttribute("aria-label", "Page dot " + (index + 1));
      ["pointerdown", "touchstart", "focusin"].forEach(function (eventName) {
        dot.addEventListener(eventName, function () {
          if (warmSlideMedia) warmSlideMedia(slides[index]);
        }, { passive: true });
      });
      dot.addEventListener("click", function (event) {
        if (isFullBundleReady() && section.querySelector(".flickity-enabled")) return;
        event.preventDefault();
        setSlide(index);
        deferBundleLoad("slideshow-dot");
      });
      dots.appendChild(dot);
    });

    sliderEl.appendChild(dots);
    return dots;
  }

  function updateCriticalPageDots(dots, activeIndex, activeSlide) {
    if (!dots) return;

    Array.prototype.forEach.call(dots.children, function (dot, index) {
      dot.classList.toggle("is-selected", index === activeIndex);
    });

    if (activeSlide && activeSlide.dataset.headerTheme) {
      dots.dataset.theme = activeSlide.dataset.headerTheme;
    }
  }

  function startCriticalDotProgress(section, dots, flickityOptions, getActiveIndex, advanceSlide, warmNextSlide) {
    if (!flickityOptions.customAutoPlay) {
      return { reset: function () {}, stop: function () {} };
    }

    var duration = flickityOptions.customAutoPlay;
    var isPaused = false;
    var startTime = Date.now();
    var pausedElapsed = 0;
    var rafId = null;
    var nextSlideWarmed = false;
    var interactionGated = section.dataset.homeHeroOptimized === "true";

    function resetProgress() {
      startTime = Date.now();
      pausedElapsed = 0;
      isPaused = false;
      nextSlideWarmed = false;
      if (dots) dots.style.setProperty("--current-progress", "0%");
    }

    function tick() {
      if (dots && !dots.isConnected) return;
      if (interactionGated && section.dataset.homeHeroInteracted !== "true") {
        rafId = null;
        return;
      }

      if (!isPaused) {
        var elapsed = Date.now() - startTime;
        var progress = Math.min((elapsed / duration) * 100, 100);
        if (dots) dots.style.setProperty("--current-progress", progress + "%");

        if (!nextSlideWarmed && duration - elapsed <= 1000) {
          nextSlideWarmed = true;
          if (warmNextSlide) warmNextSlide();
        }

        if (progress >= 100) {
          advanceSlide(getActiveIndex() + 1);
          resetProgress();
        }
      }

      rafId = window.requestAnimationFrame(tick);
    }

    section.addEventListener("mouseenter", function () {
      isPaused = true;
      pausedElapsed = Date.now() - startTime;
    });

    section.addEventListener("mouseleave", function () {
      isPaused = false;
      startTime = Date.now() - pausedElapsed;
    });

    section.addEventListener("ecoflow:home-hero-interaction", function () {
      if (!interactionGated || rafId) return;
      resetProgress();
      rafId = window.requestAnimationFrame(tick);
    });

    resetProgress();
    if (!interactionGated || section.dataset.homeHeroInteracted === "true") {
      rafId = window.requestAnimationFrame(tick);
    }

    return {
      reset: resetProgress,
      stop: function () {
        if (rafId) window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    };
  }

  function initPlainSlideshowArrows() {
    queryAll('.hp-slideshow[data-section-type="slideshow-section"]:not([data-home-hero-optimized="true"])').forEach(function (section) {
      var slides = queryAll("[data-slider-item]", section);
      var buttons = queryAll("[data-slider-button]", section);
      if (slides.length <= 1 || !buttons.length) return;

      var activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains("slideshow__slide--active");
      });
      if (activeIndex < 0) activeIndex = 0;

      function setPlainSlide(index) {
        var nextIndex = (index + slides.length) % slides.length;
        activeIndex = nextIndex;
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === nextIndex;
          slide.classList.toggle("slideshow__slide--active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });
        var header = query(".float-header");
        var theme = slides[nextIndex].dataset.headerTheme;
        if (section.dataset.matchHeader && theme && header) {
          header.classList.remove("header-theme-white", "header-theme-black");
          header.classList.add("header-theme-" + theme);
        }
      }

      buttons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          if (isFullBundleReady() && section.querySelector(".flickity-enabled")) return;
          event.preventDefault();
          setPlainSlide(button.hasAttribute("data-slider-button-next") ? activeIndex + 1 : activeIndex - 1);
          deferBundleLoad("slideshow");
        });
      });
    });
  }

  function initSlideshow() {
    var dotProgressControllers = [];

    queryAll('[data-section-type="slideshow-section"][data-home-hero-optimized="true"]').forEach(function (section) {
      var slides = queryAll("[data-slider-item]", section);
      var buttons = queryAll("[data-slider-button]", section);
      if (slides.length <= 1) return;

      var sliderEl = section.querySelector("[data-slider-container]");
      var flickityOptions = {};

      try {
        flickityOptions = JSON.parse(sliderEl.getAttribute("data-flickity-options") || "{}");
      } catch (error) {}

      var hasCriticalControls = buttons.length > 0 || flickityOptions.pageDots;

      var activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains("slideshow__slide--active");
      });
      if (activeIndex < 0) activeIndex = 0;

      var criticalDots = null;
      var dotProgress = null;
      var slideRequestId = 0;

      function markHomeHeroInteraction() {
        if (section.dataset.homeHeroInteracted === "true") return;
        section.dataset.homeHeroInteracted = "true";
        section.dispatchEvent(new CustomEvent("ecoflow:home-hero-interaction"));
      }

      ["pointerdown", "touchstart", "keydown", "focusin", "click"].forEach(function (eventName) {
        sliderEl.addEventListener(eventName, markHomeHeroInteraction, { passive: eventName !== "keydown" });
      });

      function hydrateSlideMedia(slide) {
        if (!slide) return Promise.resolve();
        if (slide.__homeSlideHydration) return slide.__homeSlideHydration;

        queryAll("source[data-home-slide-srcset], source[data-srcset]", slide).forEach(function (source) {
          var dataSrcset = source.getAttribute("data-home-slide-srcset") || source.getAttribute("data-srcset");
          source.setAttribute("srcset", dataSrcset);
          source.removeAttribute("data-home-slide-srcset");
          source.removeAttribute("data-srcset");
        });

        var images = queryAll("img.slideshow__image", slide);
        images.forEach(function (image) {
          var dataSrc = image.getAttribute("data-home-slide-src") || image.getAttribute("data-src");
          var dataSrcset = image.getAttribute("data-home-slide-srcset") || image.getAttribute("data-srcset");
          var wasDeferred = Boolean(dataSrc || dataSrcset);

          if (dataSrcset) {
            image.setAttribute("srcset", dataSrcset);
            image.removeAttribute("data-home-slide-srcset");
            image.removeAttribute("data-srcset");
          }

          if (dataSrc) {
            image.setAttribute("src", dataSrc);
            image.removeAttribute("data-home-slide-src");
            image.removeAttribute("data-src");
          }

          if (wasDeferred) image.setAttribute("loading", "eager");

          image.classList.remove("lazyload");
          image.classList.add("lazyloaded");
        });

        slide.__homeSlideHydration = Promise.all(images.map(function (image) {
          if (image.complete && image.naturalWidth > 0) {
            return image.decode ? image.decode().catch(function () {}) : Promise.resolve();
          }

          return new Promise(function (resolve) {
            var done = function () {
              image.removeEventListener("load", done);
              image.removeEventListener("error", done);
              if (image.decode) {
                image.decode().catch(function () {}).then(resolve);
              } else {
                resolve();
              }
            };
            image.addEventListener("load", done, { once: true });
            image.addEventListener("error", done, { once: true });
          });
        }));

        return slide.__homeSlideHydration;
      }

      function warmSlideMedia(slide) {
        if (!slide) return Promise.resolve();
        markHomeHeroInteraction();
        return hydrateSlideMedia(slide);
      }

      section.ecoflowWarmSlide = warmSlideMedia;

      function startWhenSlideImageReady(slide, callback) {
        var image = query("img.slideshow__image", slide);

        function startAfterPaint() {
          function startAfterLoad() {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(callback);
            });
          }

          if (doc.readyState === "complete") {
            startAfterLoad();
            return;
          }

          window.addEventListener("load", startAfterLoad, { once: true });
        }

        if (!image || image.complete) {
          startAfterPaint();
          return;
        }

        var finished = false;
        function finish() {
          if (finished) return;
          finished = true;
          image.removeEventListener("load", finish);
          image.removeEventListener("error", finish);
          startAfterPaint();
        }

        image.addEventListener("load", finish, { once: true });
        image.addEventListener("error", finish, { once: true });
      }

      function setSlide(index) {
        var nextIndex = (index + slides.length) % slides.length;
        var nextSlide = slides[nextIndex];
        var requestId = ++slideRequestId;
        activeIndex = nextIndex;
        warmSlideMedia(nextSlide);
        hydrateSlideMedia(nextSlide).then(function () {
          if (requestId !== slideRequestId) return;
          slides.forEach(function (slide, slideIndex) {
            var isActive = slideIndex === nextIndex;
            slide.classList.toggle("slideshow__slide--active", isActive);
            slide.setAttribute("aria-hidden", isActive ? "false" : "true");
          });
          updateCriticalPageDots(criticalDots, nextIndex, nextSlide);
          if (dotProgress) dotProgress.reset();
          section.dispatchEvent(new CustomEvent("slider_slide_changed", {
            detail: nextIndex
          }));
          window.setTimeout(function () {
            warmSlideMedia(slides[(nextIndex + 1) % slides.length]);
          }, 150);
        });
      }

      hydrateSlideMedia(slides[activeIndex]);

      if (flickityOptions.pageDots) {
        criticalDots = createCriticalPageDots(section, sliderEl, slides, setSlide, warmSlideMedia);
        updateCriticalPageDots(criticalDots, activeIndex, slides[activeIndex]);
      }

      // Image hydration and autoplay are independent from critical dots/arrows.
      // A control-free hero still needs to remain on slide one until interaction,
      // then start its deferred autoplay controller.
      startWhenSlideImageReady(slides[activeIndex], function () {
        if (isFullBundleReady()) return;
        dotProgress = startCriticalDotProgress(section, criticalDots, flickityOptions, function () {
          return activeIndex;
        }, setSlide, function () {
          warmSlideMedia(slides[(activeIndex + 1) % slides.length]);
        });
        dotProgressControllers.push(dotProgress);
      });

      if (!hasCriticalControls) return;

      buttons.forEach(function (button) {
        ["pointerdown", "touchstart", "focusin"].forEach(function (eventName) {
          button.addEventListener(eventName, function () {
            var targetIndex = button.hasAttribute("data-slider-button-next") ? activeIndex + 1 : activeIndex - 1;
            warmSlideMedia(slides[(targetIndex + slides.length) % slides.length]);
          }, { passive: true });
        });
        button.addEventListener("click", function (event) {
          if (isFullBundleReady() && section.querySelector(".flickity-enabled")) return;
          event.preventDefault();
          setSlide(button.hasAttribute("data-slider-button-next") ? activeIndex + 1 : activeIndex - 1);
          deferBundleLoad("slideshow");
        });
      });
    });

    window.addEventListener("ecoflow:home-full-bundle-loaded", function () {
      dotProgressControllers.forEach(function (controller) {
        if (controller) controller.stop();
      });
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (query(".flickity-enabled") || attempts >= 60) {
          window.clearInterval(timer);
          removeCriticalPageDots();
        }
      }, 50);
    }, { once: true });
  }

  function initDeferredSubmenus() {
    var submenus = queryAll("[data-home-deferred-submenu]");
    if (!submenus.length) return;

    function revealSubmenus() {
      submenus.forEach(function (submenu) {
        if (submenu.dataset.homeDeferredSubmenuReady === "true") return;
        var placeholder = query("[data-home-deferred-submenu-placeholder]", submenu);
        var content = query("[data-home-deferred-submenu-content]", submenu);
        if (!content) return;

        content.hidden = false;
        hydrateLazyMedia(content);
        if (placeholder) placeholder.hidden = true;
        submenu.dataset.homeDeferredSubmenuReady = "true";
        submenu.removeAttribute("aria-busy");
      });
    }

    function scheduleReveal(delay) {
      window.setTimeout(function () {
        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(revealSubmenus, { timeout: 2500 });
        } else {
          revealSubmenus();
        }
      }, delay);
    }

    function revealAfterInteraction() {
      ["pointerdown", "keydown", "touchstart", "scroll"].forEach(function (eventName) {
        window.removeEventListener(eventName, revealAfterInteraction, true);
      });
      scheduleReveal(800);
    }

    ["pointerdown", "keydown", "touchstart", "scroll"].forEach(function (eventName) {
      window.addEventListener(eventName, revealAfterInteraction, { once: true, passive: true, capture: true });
    });

    if (doc.readyState === "complete") {
      scheduleReveal(4500);
    } else {
      window.addEventListener("load", function () {
        scheduleReveal(4500);
      }, { once: true });
    }
  }

  function initDeferredHoverProductImages() {
    queryAll("[data-home-hover-card]").forEach(function (card) {
      function hydrateHoverImages() {
        queryAll("img[data-home-hover-image]", card).forEach(function (image) {
          if (image.dataset.homeHoverImageLoaded === "true") return;

          var dataSrc = image.getAttribute("data-home-hover-src");
          var dataSrcset = image.getAttribute("data-home-hover-srcset");

          if (dataSrcset) {
            image.setAttribute("srcset", dataSrcset);
          }

          if (dataSrc) {
            image.setAttribute("src", dataSrc);
          }

          image.dataset.homeHoverImageLoaded = "true";
          image.removeAttribute("data-home-hover-src");
          image.removeAttribute("data-home-hover-srcset");
          image.removeAttribute("data-home-hover-image");
        });
      }

      card.addEventListener("mouseenter", hydrateHoverImages, { once: true });
      card.addEventListener("focusin", hydrateHoverImages, { once: true });
    });
  }

  function initEmailSubscriptionFallback() {
    var popup = query("#email-subscription-popup");
    if (!popup) return;

    var wrapper = query(".email-subscription-popup__wrapper", popup);
    var trigger = query(".email-subscription-popup__trigger-image-wrapper", popup);
    var triggerClose = query(".email-subscription-popup__trigger-close", popup);
    var bodyClose = query(".email-subscription-popup__body-close-button", popup);
    var delaySeconds = Number(popup.getAttribute("data-popup-delay-seconds")) || 0;
    var delayDays = Number(popup.getAttribute("data-popup-delay-days")) || 0;
    var autoShow = popup.getAttribute("data-auto-show-popup") === "true";
    var delayKey = window.location.hostname + "_email_subscription_popup_delay_date";
    var createdAt = Number(popup.getAttribute("data-popup-created-at")) || 0;

    function isAlpineReady() {
      return !!(
        window.Alpine &&
        popup._x_dataStack &&
        popup._x_dataStack.some(function (data) {
          return data && typeof data.togglePopup === "function";
        })
      );
    }

    function setDelayDate() {
      if (!delayDays) return;
      var targetDay = new Date();
      targetDay.setHours(0, 0, 0, 0);
      targetDay.setDate(new Date().getDate() + delayDays);
      try {
        window.localStorage.setItem(delayKey, targetDay);
      } catch (error) {}
    }

    function isDelayDateValid() {
      try {
        var delayDate = window.localStorage.getItem(delayKey);
        return Date.now() < new Date(delayDate).getTime();
      } catch (error) {
        return false;
      }
    }

    function showTrigger() {
      popup.removeAttribute("x-cloak");
      popup.style.display = "";
      popup.dataset.homeCriticalTriggerHidden = "false";
      if (wrapper && popup.dataset.homeCriticalPopupOpen !== "true") {
        wrapper.style.display = "none";
      }
    }

    function hideTrigger() {
      popup.dataset.homeCriticalTriggerHidden = "true";
      popup.style.display = "none";
    }

    function openPopup() {
      if (!wrapper) return;
      var body = query(".email-subscription-popup__body", popup);
      var subscription = query(".email-subscription-popup__subscription", popup);
      showTrigger();
      popup.dataset.homeCriticalPopupOpen = "true";
      if (body) {
        body.classList.add("email-subscription-popup__body--subscrption");
      }
      if (subscription && !isAlpineReady()) {
        subscription.style.display = "";
      }
      wrapper.style.display = "";
      requestFullBundle("email-popup");
    }

    function closePopup() {
      if (!wrapper) return;
      popup.dataset.homeCriticalPopupOpen = "false";
      wrapper.style.display = "none";
      setDelayDate();
    }

    var shouldAutoOpen = autoShow && !isDelayDateValid();

    if (shouldAutoOpen) {
      showTrigger();
      if (wrapper) {
        wrapper.style.display = "none";
      }
      requestFullBundle("email-popup");
    } else {
      showTrigger();
    }

    if (trigger) {
      trigger.addEventListener("click", function (event) {
        if (isAlpineReady()) return;
        event.preventDefault();
        openPopup();
      });
    }

    if (triggerClose) {
      triggerClose.addEventListener("click", function (event) {
        if (isAlpineReady()) return;
        event.preventDefault();
        hideTrigger();
      });
    }

    if (bodyClose) {
      bodyClose.addEventListener("click", function (event) {
        if (isAlpineReady()) return;
        event.preventDefault();
        closePopup();
      });
    }

    queryAll(".email-subscription-popup__input, .email-subscription-popup__button--subscription", popup).forEach(function (element) {
      element.addEventListener("focus", function () {
        requestFullBundle("email-popup-form");
      });
      element.addEventListener("click", function () {
        requestFullBundle("email-popup-form");
      });
    });

    if (shouldAutoOpen) {
      var elapsed = window.performance && typeof window.performance.now === "function"
        ? window.performance.now() - createdAt
        : 0;
      var remainingDelay = Math.max(0, delaySeconds * 1000 - elapsed);
      window.setTimeout(function () {
        if (!isAlpineReady() && !isDelayDateValid()) {
          openPopup();
        }
      }, remainingDelay);
    }
  }

  function initDeferredCountrySelector() {
    var countrySelectors = queryAll('[data-country-toggle]');
    var wrapper = query('.country-selector-popup-wrapper');
    var source = query('#shopify-section-country-selector-popup');

    if (!countrySelectors.length || !wrapper || wrapper.dataset.countrySelectorBound === 'true') return;

    function ensureCountryPopup() {
      var popup = query('#country-selector-popup');
      if (popup) return popup;

      var template = query('#country-selector-popup-template');
      if (template && template.content) {
        wrapper.appendChild(template.content.cloneNode(true));
      } else if (source && source.innerHTML.trim()) {
        wrapper.insertAdjacentHTML('beforeend', source.innerHTML);
        source.innerHTML = '';
      }

      return query('#country-selector-popup');
    }

    function closeCountryPopup() {
      var popup = query('#country-selector-popup');
      if (popup) popup.classList.remove('visible');
      doc.body.classList.remove('overflow-hidden');
      var announcement = query('#shopify-section-announcement-bar');
      if (announcement) announcement.style.display = 'block';
    }

    function openCountryPopup() {
      var popup = ensureCountryPopup();
      if (!popup) return;

      if (window.innerWidth < 750) {
        var announcement = query('#shopify-section-announcement-bar');
        if (announcement) announcement.style.display = 'none';
        var mobileNavToggle = query('.js-mobile-nav-toggle');
        if (mobileNavToggle && mobileNavToggle.getAttribute('aria-expanded') === 'true') {
          mobileNavToggle.click();
        }
      }

      var visibleMenu = query('.item-has-mega-menu.visible');
      if (visibleMenu) {
        var activeNavLink = query('.nav-bar__link.active', visibleMenu);
        if (activeNavLink) activeNavLink.classList.remove('active');
        visibleMenu.classList.remove('visible');
        var menuOverlay = query('.mega_menu_overlay');
        if (menuOverlay) menuOverlay.style.display = 'none';
      }

      hydrateLazyMedia(popup);
      popup.classList.add('visible');
      doc.body.classList.add('overflow-hidden');
    }

    doc.addEventListener('pointerdown', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-country-toggle]')) {
        ensureCountryPopup();
      }
    }, { passive: true });

    doc.addEventListener('focusin', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-country-toggle]')) {
        ensureCountryPopup();
      }
    });

    doc.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-country-toggle]')) {
        openCountryPopup();
        return;
      }
      if (event.target && event.target.closest && event.target.closest('[data-country-popup-close]')) {
        closeCountryPopup();
      }
    });

    wrapper.dataset.countrySelectorBound = 'true';
  }

  ready(function () {
    initHeader();
    initDeferredCountrySelector();
    initDeferredMegaMenus();
    initPlainSlideshowArrows();
    initSlideshow();
    initDeferredSubmenus();
    initDeferredHoverProductImages();
    initEmailSubscriptionFallback();
    doc.documentElement.classList.add("home-critical-js-ready");
  });
})();
